import gql from 'graphql-tag';

export const CustomPropertyListByBusiness = `query customPropertyListByBusiness(
    $businessid: ID!
    $objecttype: [String!]
){
        customPropertyListByBusiness(
                businessid: $businessid
                objecttype: $objecttype
){
        name,value,type,table,
}}`;

export const CustomPropertyList = `query CustomPropertiesBySection($businessid: ID!, $objecttype: [String!]) {
  customPropertiesBySection(businessid: $businessid, objecttype: $objecttype) {
    fieldtype
    isrequired
    name
    objecttype
    propertyid
    options{
      label
      internal
    }
    propertyname
    dbfieldname
  }
}`;

export const CustomPropertyListByBusinessForImport = `query customPropertyListByBusinessForImport($businessid: ID!, $objecttype: [String!]) {
        customPropertyListByBusinessForImport(businessid: $businessid, objecttype: $objecttype) {
          name
          value
          type
          table
        }
      }`;

export const EditUser = `mutation EditUser($userid: ID!, $isemailrequireimport: Boolean, $isphonerequireimport: Boolean) {
  editUser(userid: $userid, isemailrequireimport: $isemailrequireimport, isphonerequireimport: $isphonerequireimport)
}`;

export const Verifyphonenumber = `
      query verifyphonenumber($phonenumber: String!,$contactid: ID!){
        verifyphonenumber(phonenumber: $phonenumber, contactid: $contactid)
      }`;

export const CreateContactEmail = gql`
mutation createContactEmail($to: String!, $fromemail: String!, $subject: String!, $status: Int!, $contactid: ID!, $ownerid: ID!, $senditnow: Boolean!, $createdby: ID!, $cc: String, $bcc: String, $fromname: String, $emailbody: String, $emailattachments: [Upload!], $taskreminderdate: String, $scheduledatetime: String, $emailtype: Int, $emailreferenceid: String, $servicesprovider: Int, $parentemailid: ID, $threadid: String,
  $signaturetype:Int,$signaturecustomhtml:String,$signatureuserid: ID,$attachmentsurls: [AttachmentsurlsInput!], $servicesproviderid: ID, $includeunsubscribelink: Boolean, $replyto: String) {
  createContactEmail(to: $to, fromemail: $fromemail, subject: $subject, status: $status, contactid: $contactid, ownerid: $ownerid, senditnow: $senditnow, createdby: $createdby, cc: $cc, bcc: $bcc, fromname: $fromname, emailbody: $emailbody, emailattachments: $emailattachments, taskreminderdate: $taskreminderdate, scheduledatetime: $scheduledatetime, emailtype: $emailtype, emailreferenceid: $emailreferenceid,signaturetype:$signaturetype,signaturecustomhtml:$signaturecustomhtml,signatureuserid:$signatureuserid, servicesprovider: $servicesprovider, parentemailid: $parentemailid, threadid: $threadid, attachmentsurls: $attachmentsurls, servicesproviderid: $servicesproviderid, includeunsubscribelink: $includeunsubscribelink, replyto: $replyto) {
    emailid
    to
    cc
    bcc
    fromemail
    fromname
    subject
    emailbody
    emailattachments
    status
    scheduledatetime
    contactid
    ownerid
    threadid
    messageid
    emailreferenceid
    servicesprovider
    emailtype
    parentemailid
    senditnow
    createdby
    updatedby
    deleted
    activityhistory
    signaturetype
    signaturecustomhtml
    signatureuserid
    emailread
    createdAt
    updatedAt
    replies {
      emailid
      to
      cc
      bcc
      fromemail
      fromname
      subject
      emailbody
      emailattachments
      status
      scheduledatetime
      contactid
      ownerid
      threadid
      messageid
      emailreferenceid
      servicesprovider
      emailtype
      parentemailid
      senditnow
      createdby
      updatedby
      deleted
      activityhistory
      emailread
      createdAt
      updatedAt
    }
    report {
      emailreportid
      messageid
      senttime
      delivereddate
      openeddate
      clickeddate
      bounceddate
      unsubscribeddate
      contactid
      locationid
      emailid
      status
      createdby
      updatedby
      deleted
      createdAt
      updatedAt
    }
  }
}`;

export const CreateContactByEmail = `
mutation createContactEmail($to: String!, $fromemail: String!, $subject: String!, $status: Int!, $contactid: ID!, $ownerid: ID!, $senditnow: Boolean!, $createdby: ID!, $cc: String, $bcc: String, $fromname: String, $emailbody: String, $emailattachments: [Upload!], $taskreminderdate: String, $scheduledatetime: String, $emailtype: Int, $emailreferenceid: String, $servicesprovider: Int, $parentemailid: ID, $threadid: String,$signaturetype:Int,$signaturecustomhtml:String,$signatureuserid: ID, $attachmentsurls: [AttachmentsurlsInput!], $servicesproviderid: ID, $includeunsubscribelink: Boolean, $replyto: String) {
  createContactEmail(to: $to, fromemail: $fromemail, subject: $subject, status: $status, contactid: $contactid, ownerid: $ownerid, senditnow: $senditnow, createdby: $createdby, cc: $cc, bcc: $bcc, fromname: $fromname, emailbody: $emailbody, emailattachments: $emailattachments, taskreminderdate: $taskreminderdate, scheduledatetime: $scheduledatetime, emailtype: $emailtype, emailreferenceid: $emailreferenceid,
  includeunsubscribelink: $includeunsubscribelink,
  signaturetype:$signaturetype,signaturecustomhtml:$signaturecustomhtml,signatureuserid:$signatureuserid, servicesprovider: $servicesprovider, parentemailid: $parentemailid, threadid: $threadid, attachmentsurls: $attachmentsurls, servicesproviderid: $servicesproviderid, replyto: $replyto) {
    emailid
    to
    cc
    bcc
    fromemail
    fromname
    subject
    emailbody
    emailattachments
    status
    scheduledatetime
    contactid
    ownerid
    threadid
    messageid
    emailreferenceid
    signaturetype
    signaturecustomhtml
    signatureuserid
    servicesprovider
    emailtype
    parentemailid
    senditnow
    createdby
    updatedby
    deleted
    activityhistory
    emailread
    createdAt
    updatedAt
    replies {
      emailid
      to
      cc
      bcc
      fromemail
      fromname
      subject
      emailbody
      emailattachments
      status
      scheduledatetime
      contactid
      ownerid
      threadid
      messageid
      emailreferenceid
      servicesprovider
      emailtype
      parentemailid
      senditnow
      createdby
      updatedby
      deleted
      activityhistory
      emailread
      createdAt
      updatedAt
    }
    report {
      emailreportid
      messageid
      senttime
      delivereddate
      openeddate
      clickeddate
      bounceddate
      unsubscribeddate
      contactid
      locationid
      emailid
      status
      createdby
      updatedby
      deleted
      createdAt
      updatedAt
    }
  }
}`;

export const EditContactEmail = gql` 
mutation editContactEmail($emailid: ID!, $updatedby: ID!, $to: String, $cc: String, $threadid: String, $bcc: String, $emailreferenceid: String, $fromemail: String, $fromname: String, $subject: String, $emailbody: String, $emailattachments: [Upload!], $status: Int, $taskreminderdate: String, $scheduledatetime: String, $contactid: ID, $ownerid: ID, $servicesprovider: Int, $senditnow: Boolean, $attachmentsurls: [AttachmentsurlsInput!],$signaturetype:Int,$signaturecustomhtml:String,$signatureuserid: ID, $emailtype: Int, $parentemailid: ID, $servicesproviderid: ID, $includeunsubscribelink: Boolean, $replyto: String) {
  editContactEmail(emailid: $emailid, updatedby: $updatedby, to: $to, cc: $cc, threadid: $threadid, bcc: $bcc, emailreferenceid: $emailreferenceid, fromemail: $fromemail, fromname: $fromname, subject: $subject, emailbody: $emailbody, emailattachments: $emailattachments, status: $status, taskreminderdate: $taskreminderdate, scheduledatetime: $scheduledatetime, contactid: $contactid, ownerid: $ownerid, servicesprovider: $servicesprovider, senditnow: $senditnow, attachmentsurls: $attachmentsurls, emailtype: $emailtype, parentemailid: $parentemailid,signaturetype:$signaturetype,signaturecustomhtml:$signaturecustomhtml,signatureuserid:$signatureuserid, servicesproviderid: $servicesproviderid, includeunsubscribelink: $includeunsubscribelink, replyto: $replyto)
}`;

export const ContactEmail = `
            query contactEmail($emailid: ID!){
                contactEmail(emailid:$emailid){
                    emailid,to,cc,servicesproviderid,bcc,fromemail,fromname,subject,emailbody,emailattachments,status,scheduledatetime,contactid,
                    replies{emailid,to,cc, threadid,fromemail,fromname,subject, emailbody, emailattachments},senditnow,servicesprovider,createdby,updatedby,
                    deleted,createdAt,updatedAt,signaturetype, emailtype,
                    signaturecustomhtml,signatureuserid, replyto
             }}`;

export const Emailsettingsbyuser = `
query emailsettingsbyuser($ownerid: ID!,$isemail: Boolean){
  emailsettingsbyuser(ownerid:$ownerid, isemail:$isemail){
    emailsettingid,accountid,refreshtoken,accesstoken,historyid,useremail,accesstokenexpirydate,status,servicesprovider,createdby,updatedby,
    deleted,locationid,ownerid,iscalendar,isemail,iscontact,isdefaultemail,createdAt,updatedAt, errormessage,
 }}`;
export const Employeesizeyearsrevenuecategories = `query employeesizeyearsrevenuecategories($locationid: ID) {
        employeesizeyearsrevenuecategories(locationid: $locationid) {
          employeesize
          revenue
          yearsinbusiness
          categories
          typeofentity
          businessstartdate
        }
      }
      
      `;

export const SectionsByBusinessWithProperty = `query sectionsByBusinessWithProperty($businessid:ID!,$objecttype: String){
  sectionsByBusinessWithProperty(businessid: $businessid, objecttype:$objecttype){
    sectionid,name,description,locationid,objecttype,iscommon,allowtoeditdelete,deleted,businessid,createdby,
    updatedby,propertiescount,properties{propertyid,name,label,sectionid,fieldtype,options,dbfieldname,description,locationid,
    objecttype,iscommon,allowtoeditdelete,isrequired,isshowinform,deleted,businessid,createdby,updatedby,createdUser{userid,firstname,lastname,phonenumber,email},
    createdAt,updatedAt}createdUser{userid,firstname,lastname,phonenumber,email},createdAt,updatedAt,
    properties{propertyid,name,label,sectionid,fieldtype,options,dbfieldname,description,locationid,objecttype,iscommon,allowtoeditdelete,
    isrequired,isshowinform,deleted,businessid,createdby,updatedby,createdAt,updatedAt}
  }}`;

export const ContactlistByLocation = `
query contactlistbylocation($locationid:ID!,$pagenumber:Int!,$pagesize:Int!,$searchtext:String, $contactid: ID){
  contactlistbylocation(locationid:$locationid,pagenumber:$pagenumber,pagesize:$pagesize,searchtext:$searchtext, contactid: $contactid){
    count 
    rows{ 
      contactid
       primaryemail
       firstname
       lastname
       fullname
       phonenumber
       lifecyclestage
       organizationname
       organizationid
      } 
    }
  }`;

export const SavedFiltersByUser = `query savedfiltersbyuser($ownerid: ID!, $locationid: ID!, $type: Int) {
  savedfiltersbyuser(ownerid: $ownerid, locationid: $locationid, type: $type) {
    filterid
    name
    description
    businessid
    table
    type
    query
    createdby
    updatedby
    locationid
    deleted
  }
}`;

export const PinFilter = `mutation pinFilter($filterid: ID!, $locationid: ID!, $type: Int, $isforallrecords: Boolean, $ownerid: ID, $createdby: ID, $businessid: ID) {
  pinFilter(filterid: $filterid, locationid: $locationid, type: $type, isforallrecords: $isforallrecords, ownerid: $ownerid, createdby: $createdby, businessid: $businessid)
}`;

export const Editsavedfilter = `mutation editsavedfilter($filterid: ID!, $name: String!, $table: String!, $locationid: ID!, $description: String, $businessid: ID, $type: Int, $query: String, $ownerid: ID, $updatedby: ID) {
  editsavedfilter(filterid: $filterid, name: $name, table: $table, locationid: $locationid, description: $description, businessid: $businessid, type: $type, query: $query, ownerid: $ownerid, updatedby: $updatedby)
}`;

export const TeamsByBusiness = `query teamsbybusiness($businessid: ID!) {
  teamsbybusiness(businessid: $businessid) {
    teamid
    name
    memberlist {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
    }
    createdUser {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
    }
    businessid
    locationid
    createdby
    updatedby
    createdAt
    updatedAt
  }
}`;

export const UserListByBusinessAndLocation = `query userListByBusinessAndLocation($businessid: ID!, $locationid: ID!, $includeusersid: [ID]) {
  userListByBusinessAndLocation(businessid: $businessid, locationid: $locationid, includeusersid: $includeusersid) {
    userid
    roleid
    firstname
    lastname
    phonenumber
    email
    role
    lastlogin
    deleted
    usertype
    businessid
    locationid
    defaultcontactview
  }
}`;

export const ContactEmailsByContact = `query contactEmailsByContact($contactid: ID!) {
  contactEmailsByContact(contactid: $contactid) {
    emailid
    to
    cc
    bcc
    fromemail
    fromname
    subject
    emailbody
    emailattachments
    status
    scheduledatetime
    contactid
    ownerid
    threadid
    messageid
    emailreferenceid
    servicesprovider
    emailtype
    parentemailid
    senditnow
    createdby
    updatedby
    deleted
    activityhistory
    emailread
    createdAt
    updatedAt
    replies {
      emailid
      to
      cc
      bcc
      fromemail
      fromname
      subject
      emailbody
      emailattachments
      status
      scheduledatetime
      contactid
      ownerid
      threadid
      messageid
      emailreferenceid
      servicesprovider
      emailtype
      parentemailid
      senditnow
      createdby
      updatedby
      deleted
      activityhistory
      emailread
      createdAt
      updatedAt
    }
    report {
      emailreportid
      messageid
      senttime
      delivereddate
      openeddate
      clickeddate
      bounceddate
      unsubscribeddate
      contactid
      locationid
      emailid
      status
      createdby
      updatedby
      deleted
      createdAt
      updatedAt
    }
  }
}`;

export const ContactDataById = `
query contact($contactid: ID!){
  contact(contactid:$contactid){
    contactid,primaryemail,secondaryemail,firstname,lastname,officephonenumber,homephonenumber,lifecyclestage,locationid,
    createdby,updatedby,deleted,tags,ownerid,source,address{addressid,street1,street2,city,county,stateid,countryid,addresstype,zip,country{countryid,name},state{stateid,name}},
    createdAt,updatedAt,phonecountryid,status,attribute1,attribute2,attribute3,attribute4,attribute5,attribute6,attribute7,attribute8,
    attribute9,attribute10,attribute11,attribute12,attribute13,attribute14,attribute15,attribute16,attribute17,attribute18,attribute19,attribute20,attribute21,attribute22,attribute23,
    attribute24,attribute25,attribute26,attribute27,attribute28,attribute29,attribute30,attribute31,attribute32,attribute33,attribute34,attribute35,attribute36,
    attribute37,attribute38,attribute39,attribute40,attribute41,attribute42,attribute43,attribute44,attribute45,attribute46,attribute47,
    attribute48, attribute49,attribute50,teams,linkedin
}}`;

export const CreateContactTask = `mutation CreateContactTask($taskname: String!, $createdby: ID!, $taskdescription: String, $tasktype: Int, $priority: Int, $duedate: String, $remindertype: Int, $reminderdate: String, $assigneduser: [ID!], $status: Int, $associatedconnnect: [ID!], $ownerid: ID, $timezone: String, $eventtiming: Int, $iscreateevent: Boolean, $contactid: ID, $locationid: ID) {
  createContactTask(taskname: $taskname, createdby: $createdby, taskdescription: $taskdescription, tasktype: $tasktype, priority: $priority, duedate: $duedate, remindertype: $remindertype, reminderdate: $reminderdate, assigneduser: $assigneduser, status: $status, associatedconnnect: $associatedconnnect, ownerid: $ownerid, timezone: $timezone, eventtiming: $eventtiming, iscreateevent: $iscreateevent, contactid: $contactid, locationid: $locationid) {
    taskid
    taskname
    taskdescription
    tasktype
    priority
    duedate
    remindertype
    reminderdate
    assigneduser
    status
    associatedconnnect
    ownerid
    createdby
    updatedby
    deleted
    isarchived
    contactid
    comments {
      commentid
      description
      parentid
      type
      status
      createdby
      updatedby
      deleted
      contactid
      createdAt
      updatedAt
    }
    assignedusers {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
    }
    createdUser {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
    }
    updatedUser {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
    }
    associatedconnnects {
      contactid
      primaryemail
      secondaryemail
      firstname
      lastname
      contactavatar
      officephonenumber
      phonenumber
      homephonenumber
      lifecyclestage
      locationid
      createdby
      updatedby
      deleted
      jobid
      tags
      ownerid
      organizationid
      source
      twitter
      createdAt
      updatedAt
      phonecountryid
      linkedin
      facebook
      status
      openemail
      opentask
      opennote
      opendocument
      istargetlist
      ispininchat
      lasteventdate
      issmsblock
      leadscore
      teams
      notecount
      taskcount
      emailcount
      dealscount
      documentcount
      emailstatus
      phonenostatus
      phoneverifydata
    }
    createdAt
    updatedAt
    timezone
    eventtiming
  }
}`;

export const CreateContactNote = `mutation createContactNote($notesubject: String!, $createdby: ID!, $notedescription: String, $assingedtocontact: [ID!], $parententityid: ID, $entitytype: Int, $ownerid: ID, $contactid: ID) {
  createContactNote(notesubject: $notesubject, createdby: $createdby, notedescription: $notedescription, assingedtocontact: $assingedtocontact, parententityid: $parententityid, entitytype: $entitytype, ownerid: $ownerid, contactid: $contactid) {
    contactnoteid
    notesubject
    notedescription
    assingedtocontact
    parententityid
    entitytype
    ownerid
    createdby
    updatedby
    deleted
    contactid
    comments {
      commentid
      description
      parentid
      type
      status
      createdby
      updatedby
      deleted
      contactid
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
    readstatus
  }
}`;

export const ContactNotesByContact = `query contactNotesByContact($contactid: ID!, $orderby: String) {
  contactNotesByContact(contactid: $contactid, orderby: $orderby) {
    contactnoteid
    notesubject
    notedescription
    assingedtocontact
    parententityid
    entitytype
    ownerid
    createdby
    updatedby
    deleted
    contactid
    comments {
      commentid
      description
      parentid
      type
      status
      createdby
      updatedby
      deleted
      contactid
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
    readstatus
  }
}`;

export const EditContactNote = `mutation editContactNote($contactnoteid: ID!, $notesubject: String!, $updatedby: ID!, $notedescription: String, $assingedtocontact: [ID!], $parententityid: ID, $entitytype: Int, $ownerid: ID, $contactid: ID) {
  editContactNote(contactnoteid: $contactnoteid, notesubject: $notesubject, updatedby: $updatedby, notedescription: $notedescription, assingedtocontact: $assingedtocontact, parententityid: $parententityid, entitytype: $entitytype, ownerid: $ownerid, contactid: $contactid)
}`;

export const ContactNote = `query contactNote($contactnoteid: ID!) {
  contactNote(contactnoteid: $contactnoteid) {
    contactnoteid
    notesubject
    notedescription
    assingedtocontact
    parententityid
    entitytype
    ownerid
    createdby
    updatedby
    deleted
    contactid
    comments {
      commentid
      description
      parentid
      type
      status
      createdby
      updatedby
      deleted
      contactid
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
    readstatus
  }
}`;

export const ContactTasksByContact = `query contactTasksByContact($contactid: ID!, $searchtext: String, $status: Int, $orderby: String) {
  contactTasksByContact(contactid: $contactid, searchtext: $searchtext, status: $status, orderby: $orderby) {
    taskid
    taskname
    taskdescription
    tasktype
    priority
    duedate
    remindertype
    reminderdate
    assigneduser
    status
    associatedconnnect
    ownerid
    createdby
    updatedby
    deleted
    isarchived
    contactid
    ownerUser {
      firstname
      lastname
      userid
      email
    }
    comments {
      commentid
      description
      parentid
      type
      status
      createdby
      updatedby
      deleted
      contactid
      createdAt
      updatedAt
    }
    assignedusers {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
    }
    createdUser {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
    }
    updatedUser {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
    }
    associatedconnnects {
      contactid
      primaryemail
      firstname
      lastname
      phonenumber
      lifecyclestage
    }
    createdAt
    updatedAt
    timezone
    eventtiming
  }
}`;

export const ContactTask = `query contactTask($taskid: ID!) {
  contactTask(taskid: $taskid) {
    taskid
    taskname
    taskdescription
    tasktype
    priority
    duedate
    remindertype
    reminderdate
    assigneduser
    status
    associatedconnnect
    ownerid
    createdby
    updatedby
    deleted
    isarchived
    contactid
    comments {
      commentid
      description
      parentid
      type
      status
      createdby
      updatedby
      deleted
      contactid
      createdAt
      updatedAt
    }
    assignedusers {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
    }
    ownerUser {
      firstname
      lastname
      userid
      email
    } 
    createdUser {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
    }
    updatedUser {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
    }
    associatedconnnects {
      contactid
      primaryemail
      firstname
      lastname
      phonenumber
      lifecyclestage
      locationid
      organization {
        name
        organizationid
      }
    }
    createdAt
    updatedAt
    timezone
    eventtiming
  }
}`;

export const ContactAddressByContactid = `query contactAddressByContactid($addresstype: Int!, $organizationid: ID, $contactid: ID) {
  contactAddressByContactid(addresstype: $addresstype, organizationid: $organizationid, contactid: $contactid) {
    addressid
    street1
    street2
    city
    county
    stateid
    countryid
    zip
    createdby
    updatedby
    locationid
    organizationid
    addresstype
    country {
      countryid
      name
      code
      flag
      phonecode
      createdby
      updatedby
    }
    state {
      stateid
      name
      statename
      code
      createdby
      updatedby
    }
  }
}`;

export const CreateOrUpdateContactAddress = `mutation createOrUpdateContactAddress($street1: String, $street2: String, $city: String, $county: String, $stateid: Int, $state: String, $addresstype: Int, $countryid: Int, $zip: String, $createdby: ID, $contactid: ID, $organizationid: ID, $locationid: ID) {
  createOrUpdateContactAddress(street1: $street1, street2: $street2, city: $city, county: $county, stateid: $stateid, state: $state, addresstype: $addresstype, countryid: $countryid, zip: $zip, createdby: $createdby, contactid: $contactid, organizationid: $organizationid, locationid: $locationid) {
    addressid,street1,street2,city,county,stateid,countryid,addresstype,zip,country{countryid},state{stateid,name}
  }
}`;

export const Organizationbylocation = `query organizationbylocation($locationid: ID!, $pagenumber: Int!, $pagesize: Int!, $searchtext: String, $organizationid: ID) {
  organizationbylocation(locationid: $locationid, pagenumber: $pagenumber, pagesize: $pagesize, searchtext: $searchtext, organizationid: $organizationid) {
    count
    rows {
      organizationid
      name
    }
  }
}`;

export const ContactFormSettingsByLocation = `query Contactformsettingsbylocation($locationid: ID!) {
  contactformsettingsbylocation(locationid: $locationid) {
    formid
    formtype
    featureimageurl
    callouttext
    calloutbody
    calloutbuttontext
    themecolor
    backgroundcolor
    textcolor
    calloutbuttontype
    calloutbuttonlink
    formbody
    name
    calloutimageposition
    calloutbuttonfileurl
    isshowfiledselection
    triggeronload
    isfixedposition
    triggerposition
    status
    activedate
    isfirstnameshow
    islastnameshow
    isemailshow
    isphoneshow
    formsubmitbuttontext
    contactlifecyclestage
    thanksmessage
    isshowthanksbutton
    thanksbuttontext
    thanksbuttontype
    thanksbuttonlink
    thanksbuttonfileurl
    triggeronhalfpagecroll
    triggeronexitintent
    triggerafterelapsedtime
    triggertime
    popupshowcount
    impressions
    locationid
    createdby
    updatedby
    deleted
    issendthanksemail
    issendthankssms
    thanksemailconfig
    thankssmsconfig
    openeddata
    clickeddata
    createdAt
    updatedAt
    workflowid
    termenable
    termdesc
    captchaenable
    calloutbtnposition
    formposition
    isshowfooterlogo
  }
}`;



export const ContactformsettingsWithPagination = `query ContactformsettingsWithPagination($locationid: ID!, $pagenumber: Int, $pagesize: Int, $searchtext: String) {
  contactformsettingsWithPagination(locationid: $locationid, pagenumber: $pagenumber, pagesize: $pagesize, searchtext: $searchtext) {
    count
    rows {
      formid
    name
    formtype
    formbody
    callouttext
    featureimageurl
    thanksmessage
    popupshowcount
    status
    activedate
    impressions
    }
  }
}`

export const Contactformsettingreport = `
query contactformsettingreport($formid: ID!) {
  contactformsettingreport(formid: $formid) {
    formid
    formtype
    featureimageurl
    callouttext
    calloutbody
    calloutbuttontext
    themecolor
    backgroundcolor
    textcolor
    calloutbuttontype
    calloutbuttonlink
    formbody
    name
    calloutimageposition
    calloutbuttonfileurl
    isshowfiledselection
    triggeronload
    isfixedposition
    triggerposition
    status
    activedate
    isfirstnameshow
    islastnameshow
    isemailshow
    isphoneshow
    formsubmitbuttontext
    contactlifecyclestage
    thanksmessage
    isshowthanksbutton
    thanksbuttontext
    thanksbuttontype
    thanksbuttonlink
    thanksbuttonfileurl
    triggeronhalfpagecroll
    triggeronexitintent
    triggerafterelapsedtime
    triggertime
    popupshowcount
    impressions
    locationid
    createdby
    updatedby
    deleted
    createdAt
    updatedAt
    issendthanksemail
    issendthankssms
    thanksemailconfig
    thankssmsconfig
    openeddata
    clickeddata
    owneruser {
      userid
      firstname
      lastname
      phonenumber
      email
    }
    formcontacts {
      contactid
      formid
      createdAt
      updatedAt
      ip
      city
      state
      country
      formcontactdata {
        contactid
        primaryemail
        firstname
        lastname
        phonenumber
        lifecyclestage
        locationid
        jobid
        ownerid
      }
    }
  }
}`;

export const CreateUrl = `mutation
createurl(
  $fullurl: String!
  $sorturlcode: String
  $deleted: Boolean
  $userid: ID
){
  createurl(
    fullurl: $fullurl
    sorturlcode: $sorturlcode
    deleted: $deleted
    userid: $userid
      ){urlid,fullurl,sorturlcode,userid,createdAt,updatedAt}
    }`;

export const OrganizationByLocationWithPagination = `
query organizationbylocationwithpagination($pagenumber: Int,$pagesize: Int,$locationid: ID!, $searchtext: String, $sortby: SortBy){
 organizationbylocationwithpagination(pagenumber: $pagenumber,pagesize: $pagesize,locationid:$locationid, searchtext: $searchtext, sortby: $sortby){
   count,
   selectedColumn {
    columnname
    dbcolumnname
    table
    datatype
  },
  rows{organizationid,name,locationid,orgphonenumber,orgemail,categories,employeesize,yearsinbusiness,revenue,businessstartdate,typeofentity,contactcount,
     orgmap, address {addressid,street1,street2,city,county,stateid,countryid,zip,country{countryid,name},state {stateid,name},}
   orgwebsite,orgtwitter,orgfacebook,orgstatus,orglinkedin,orggmb,orgyelp,orgtripadvisor,createdby,updatedby,phonecountryid,createdAt,updatedAt,orgyoutubeurl,
   orgattribute1,
   orgattribute2,
   orgattribute3,
   orgattribute4,
   orgattribute5,
   orgattribute6,
   orgattribute7,
   orgattribute8,
   orgattribute9,
   orgattribute10,
   orgattribute11,
   orgattribute12,
   orgattribute13,
   orgattribute14,
   orgattribute15,
   orgattribute16,
   orgattribute17,
   orgattribute18,
   orgattribute19,
   orgattribute20,
   orgattribute21,
   orgattribute22,
   orgattribute23,
   orgattribute24,
   orgattribute25,
   orgattribute26,
   orgattribute27,
   orgattribute28,
   orgattribute29,
   orgattribute30,
   orgattribute31,
   orgattribute32,
   orgattribute33,
   orgattribute34,
   orgattribute35,
   orgattribute36,
   orgattribute37,
   orgattribute38,
   orgattribute39,
   orgattribute40,
   orgattribute41,
   orgattribute42,
   orgattribute43,
   orgattribute44,
   orgattribute45,
   orgattribute46,
   orgattribute47,
   orgattribute48,
   orgattribute49,
   orgattribute50 }}}`;

export const createOrGetContact = `
   mutation 
   createOrGetContact(
     $contactid: ID
     $primaryemail: String
     $secondaryemail: String
     $firstname: String!
     $lastname: String
     $locationid: ID!
     $website: String
     $organizationname: String
     $jobid: String,
     $phonenumber: String
     $lifecyclestage: String!
     $linkedin: String
     $source: [String!]
     $ownerid: ID
     $createdby: ID
     $status: Int
     $productid: ID
     $paymentid: ID
   ){ 
     createOrGetContact(
       contactid: $contactid
       primaryemail: $primaryemail
       secondaryemail: $secondaryemail
       firstname: $firstname
       lastname: $lastname
       locationid: $locationid
       source: $source,
       website: $website
       organizationname: $organizationname
       linkedin: $linkedin
       jobid: $jobid,
       phonenumber: $phonenumber
       lifecyclestage: $lifecyclestage
       ownerid: $ownerid
       createdby: $createdby
       status: $status
       productid: $productid
       paymentid: $paymentid
               ){
         contactid,primaryemail,firstname,lastname,phonenumber,lifecyclestage,locationid,
         createdby,updatedby,ownerid,source,createdAt,updatedAt,status,jobid,linkedin
               }
       }`;

export const CreateContact = `
       mutation 
       createContact(
           $primaryemail: String
           $secondaryemail: String
           $firstname: String!
           $lastname: String
           $locationid: ID!
           $officephonenumber: String
           $organizationname: String
           $phonenumber: String
           $organizationid: ID
           $lifecyclestage: String!
           $jobid: String
           $tags: [String!]
           $ownerid: ID!
           $status: Int!
           $source: [String!]
           $createdby: ID!
           $phonecountryid: ID
       ){ 
               createContact(
                   primaryemail: $primaryemail,
                   secondaryemail: $secondaryemail,
                   firstname: $firstname,
                   lastname: $lastname,
                   organizationid:$organizationid,
                   locationid: $locationid,
                   organizationname: $organizationname,
                   officephonenumber: $officephonenumber,
                   phonenumber: $phonenumber,
                   lifecyclestage: $lifecyclestage,
                   jobid: $jobid,
                   tags: $tags,
                   source: $source,
                   status: $status,
                   ownerid: $ownerid,
                   createdby: $createdby,
                   phonecountryid: $phonecountryid
                   ){
                       contactid
                       lifecyclestage
                       primaryemail
                       firstname
                       lastname
                       tags
                       ownerid
                       organizationid
                       status
                       source
                       phonenumber  
                       locationid 
                       createdby
                   }
}`;

export const UpdateContact = `
mutation updateContact($contactid: ID!, $primaryemail: String, $secondaryemail: String, $contactavatar: Upload, $firstname: String, $totalreview: Float, $nps: Float, $linkedin: String, $facebook: String, $lastname: String, $locationid: ID, $updatedby: ID, $organizationid: ID, $officephonenumber: String, $phonenumber: String, $lifecyclestage: String, $jobid: String, $tags: [String!], $source: [String!], $status: Int, $ownerid: ID, $businessid: ID, $teams: [ID!], $twitter: String, $phonecountryid: ID, $ispininchat: Boolean, $lasteventdate: String, $issmsblock: Boolean, $subscriptionstatus: Int, $emailsubscriptiondate: String, $emailunsubscriptiondate: String, $emailstatus: Int, $attribute1: String, $attribute2: String, $attribute3: String, $attribute4: String, $attribute5: String, $attribute6: String, $attribute7: String, $attribute8: String, $attribute9: String, $attribute10: String, $attribute11: String, $attribute12: String, $attribute13: String, $attribute14: String, $attribute15: String, $attribute16: String, $attribute17: String, $attribute18: String, $attribute19: String, $attribute20: String, $attribute21: String, $attribute22: String, $attribute23: String, $attribute24: String, $attribute25: String, $attribute26: String, $attribute27: String, $attribute28: String, $attribute29: String, $attribute30: String, $attribute31: String, $attribute32: String, $attribute33: String, $attribute34: String, $attribute35: String, $attribute36: String, $attribute37: String, $attribute38: String, $attribute39: String, $attribute40: String, $attribute41: String, $attribute42: String, $attribute43: String, $attribute44: String, $attribute45: String, $attribute46: String, $attribute47: String, $attribute48: String, $attribute49: String, $attribute50: String) {
  updateContact(contactid: $contactid, primaryemail: $primaryemail, secondaryemail: $secondaryemail, contactavatar: $contactavatar, firstname: $firstname, totalreview: $totalreview, nps: $nps, linkedin: $linkedin, facebook: $facebook, lastname: $lastname, locationid: $locationid, updatedby: $updatedby, organizationid: $organizationid, officephonenumber: $officephonenumber, phonenumber: $phonenumber, lifecyclestage: $lifecyclestage, jobid: $jobid, tags: $tags, source: $source, status: $status, ownerid: $ownerid, businessid: $businessid, teams: $teams, twitter: $twitter, phonecountryid: $phonecountryid, ispininchat: $ispininchat, lasteventdate: $lasteventdate, issmsblock: $issmsblock, subscriptionstatus: $subscriptionstatus, emailsubscriptiondate: $emailsubscriptiondate, emailunsubscriptiondate: $emailunsubscriptiondate, emailstatus: $emailstatus, attribute1: $attribute1, attribute2: $attribute2, attribute3: $attribute3, attribute4: $attribute4, attribute5: $attribute5, attribute6: $attribute6, attribute7: $attribute7, attribute8: $attribute8, attribute9: $attribute9, attribute10: $attribute10, attribute11: $attribute11, attribute12: $attribute12, attribute13: $attribute13, attribute14: $attribute14, attribute15: $attribute15, attribute16: $attribute16, attribute17: $attribute17, attribute18: $attribute18, attribute19: $attribute19, attribute20: $attribute20, attribute21: $attribute21, attribute22: $attribute22, attribute23: $attribute23, attribute24: $attribute24, attribute25: $attribute25, attribute26: $attribute26, attribute27: $attribute27, attribute28: $attribute28, attribute29: $attribute29, attribute30: $attribute30, attribute31: $attribute31, attribute32: $attribute32, attribute33: $attribute33, attribute34: $attribute34, attribute35: $attribute35, attribute36: $attribute36, attribute37: $attribute37, attribute38: $attribute38, attribute39: $attribute39, attribute40: $attribute40, attribute41: $attribute41, attribute42: $attribute42, attribute43: $attribute43, attribute44: $attribute44, attribute45: $attribute45, attribute46: $attribute46, attribute47: $attribute47, attribute48: $attribute48, attribute49: $attribute49, attribute50: $attribute50)
}`;

export const CRMcontactByData = `
query Contact($contactid: ID!) {
  contact(contactid: $contactid) {
    contactid
    primaryemail
    secondaryemail
    firstname
    lastname
    contactavatar
    officephonenumber
    phonenumber
    lifecyclestage
    locationid
    jobid
    tags
    ownerid
    organizationid
    source
    twitter
    phonecountryid
    linkedin
    facebook
    status
    openemail
    opentask
    opennote
    opendocument
    lasteventdate
    organization {
      organizationid
      name
    }
    istargetlist
    owneruser {
      userid
      roleid
      firstname
      lastname
      phonenumber
      email
      role
      lastlogin
      deleted
      usertype
      businessid
      locationid
      defaultcontactview
      createdAt
      avatar
    }
    ispininchat
    issmsblock
    leadscore
    subscriptionstatus
    emailsubscriptiondate
    emailunsubscriptiondate
    attribute1
    attribute2
    attribute3
    attribute4
    attribute5
    attribute6
    attribute7
    attribute8
    attribute9
    attribute10
    attribute11
    attribute12
    attribute13
    attribute14
    attribute15
    attribute16
    attribute17
    attribute18
    attribute19
    attribute20
    attribute21
    attribute22
    attribute23
    attribute24
    attribute25
    attribute26
    attribute27
    attribute28
    attribute29
    attribute30
    attribute31
    attribute32
    attribute33
    attribute34
    attribute35
    attribute36
    attribute37
    attribute38
    attribute39
    attribute40
    attribute41
    attribute42
    attribute43
    attribute44
    attribute45
    attribute46
    attribute47
    attribute48
    attribute49
    attribute50
    teams
    notecount
    taskcount
    emailcount
    dealscount
    documentcount
    emailmarketingcount {
      contactid
      count
    }
    reviewcount {
      contactid
      count
    }
    emailstatus
    phonenostatus
    phoneverifydata
  }
}`;

export const Updatecontacts = `mutation Updatecontacts($contactids: [ID!], $ownerid: ID, $lifecyclestage: String, $status: Int, $tags: [String!], $source: [String!], $teams: [ID!], $subscriptionstatus: Int, $emailsubscriptiondate: String, $locationid: ID, $emailunsubscriptiondate: String, $searchText: String, $advancedfilter: [AdvancedFilter!], $filterid: ID, $selectiontype: Int, $workflowid: ID, $automationid: ID, $attribute1: String, $attribute2: String, $attribute3: String, $attribute4: String, $attribute5: String, $attribute6: String, $attribute7: String, $attribute8: String, $attribute9: String, $attribute10: String, $attribute11: String, $attribute12: String, $attribute13: String, $attribute14: String, $attribute15: String, $attribute16: String, $attribute17: String, $attribute18: String, $attribute19: String, $attribute20: String, $attribute21: String, $attribute22: String, $attribute23: String, $attribute24: String, $attribute25: String, $attribute26: String, $attribute27: String, $attribute28: String, $attribute29: String, $attribute30: String, $attribute31: String, $attribute32: String, $attribute33: String, $attribute34: String, $attribute35: String, $attribute36: String, $attribute37: String, $attribute38: String, $attribute39: String, $attribute40: String, $attribute41: String, $attribute42: String, $attribute43: String, $attribute44: String, $attribute45: String, $attribute46: String, $attribute47: String, $attribute48: String, $attribute49: String, $attribute50: String) {
  updatecontacts(contactids: $contactids, ownerid: $ownerid, lifecyclestage: $lifecyclestage, status: $status, tags: $tags, source: $source, teams: $teams, subscriptionstatus: $subscriptionstatus, emailsubscriptiondate: $emailsubscriptiondate, locationid: $locationid, emailunsubscriptiondate: $emailunsubscriptiondate, searchText: $searchText, advancedfilter: $advancedfilter, filterid: $filterid, selectiontype: $selectiontype, workflowid: $workflowid, automationid: $automationid, attribute1: $attribute1, attribute2: $attribute2, attribute3: $attribute3, attribute4: $attribute4, attribute5: $attribute5, attribute6: $attribute6, attribute7: $attribute7, attribute8: $attribute8, attribute9: $attribute9, attribute10: $attribute10, attribute11: $attribute11, attribute12: $attribute12, attribute13: $attribute13, attribute14: $attribute14, attribute15: $attribute15, attribute16: $attribute16, attribute17: $attribute17, attribute18: $attribute18, attribute19: $attribute19, attribute20: $attribute20, attribute21: $attribute21, attribute22: $attribute22, attribute23: $attribute23, attribute24: $attribute24, attribute25: $attribute25, attribute26: $attribute26, attribute27: $attribute27, attribute28: $attribute28, attribute29: $attribute29, attribute30: $attribute30, attribute31: $attribute31, attribute32: $attribute32, attribute33: $attribute33, attribute34: $attribute34, attribute35: $attribute35, attribute36: $attribute36, attribute37: $attribute37, attribute38: $attribute38, attribute39: $attribute39, attribute40: $attribute40, attribute41: $attribute41, attribute42: $attribute42, attribute43: $attribute43, attribute44: $attribute44, attribute45: $attribute45, attribute46: $attribute46, attribute47: $attribute47, attribute48: $attribute48, attribute49: $attribute49, attribute50: $attribute50)
}`;

export const DeleteTags = `mutation DeleteTags($contactids: [ID!], $tags: [String!]) {
  deleteTags(contactids: $contactids, tags: $tags)
}`;

export const UpdateExistingTags = `mutation UpdateExistingTags($contactids: [ID!], $existingtag: String, $newtag: String) {
  updateExistingTags(contactids: $contactids, existingtag: $existingtag, newtag: $newtag)
}`;

export const ContactsSources = `query contactssources($businessid:ID){
  contactssources(businessid:$businessid)
  }`;

export const ContactsTags = `query contactsTags($businessid:ID, $locationid: ID){
    contactsTags(businessid:$businessid, locationid: $locationid)
}`;

export const ContactTagsByLocation = `query contactTagsBylocation($locationid: ID) {
  contactTagsBylocation(locationid: $locationid)
}`;

export const Contactsbypaging = `query contactsbypaging($locationid: ID!, $pageNumber: Int!, $pageSize: Int!, $lifecyclestage: [String!], $searchText: String, $startdate: String, $enddate: String, $countryids: [Int!], $city: [String!], $state: [Int!], $jobid: [String!], $tags: [String!], $source: [String!], $status: [Int!], $istargetlist: Boolean, $minleadscore: Int, $maxleadscore: Int, $sortby: SortBy, $querydata: [QueryDataInput!], $employeesize: [String!], $yearsinbusiness: [Int!], $revenue: [Int!], $businessstartdate: [String!], $typeofentity: [String!], $isphonenumber: Boolean, $advancedfilter: [AdvancedFilter!], $filterid: ID, $systemfilters: [SystemFiltersInput!], $isrecipient: Boolean) {
  contactsbypaging(locationid: $locationid, pageNumber: $pageNumber, pageSize: $pageSize, lifecyclestage: $lifecyclestage, searchText: $searchText, startdate: $startdate, enddate: $enddate, countryids: $countryids, city: $city, state: $state, jobid: $jobid, tags: $tags, source: $source, status: $status, istargetlist: $istargetlist, minleadscore: $minleadscore, maxleadscore: $maxleadscore, sortby: $sortby, querydata: $querydata, employeesize: $employeesize, yearsinbusiness: $yearsinbusiness, revenue: $revenue, businessstartdate: $businessstartdate, typeofentity: $typeofentity, isphonenumber: $isphonenumber, advancedfilter: $advancedfilter, filterid: $filterid, systemfilters: $systemfilters, isrecipient: $isrecipient) {
    count
    rows {
      contactid
      primaryemail
      secondaryemail
      fullname
      firstname
      lastname
      contactavatar
      officephonenumber
      phonenumber
      homephonenumber
      lifecyclestage
      locationid
      createdby
      updatedby
      organizationid
      deleted
      istargetlist
      jobid
      tags
      ownerid {
        userid
        roleid
        firstname
        lastname
        phonenumber
        email
        role
        lastlogin
        deleted
        usertype
        businessid
        locationid
        defaultcontactview
        createdAt
        avatar
      }
      source
      twitter
      createdAt
      updatedAt
      phonecountryid
      linkedin
      facebook
      status
      openemail
      opentask
      opennote
      totalemailcampaign
      totaldealamount
      addressid
      street1
      street2
      city
      stateid
      state
      countryid
      zip
      addresstype
      countryname
      statename
      organizationname
      leadscore
      totaltaskcount
      activetaskcount
      overduetaskcount
      completedtaskcount
      totaldealcount
      ispininchat
      lasteventdate
      issmsblock
      teams {
        teamid
        name
        businessid
        locationid
        createdby
        updatedby
        createdAt
        updatedAt
      }
      subscriptionstatus
      emailsubscriptiondate
      emailunsubscriptiondate
      attribute1
      attribute2
      attribute3
      attribute4
      attribute5
      attribute6
      attribute7
      attribute8
      attribute9
      attribute10
      attribute11
      attribute12
      attribute13
      attribute14
      attribute15
      attribute16
      attribute17
      attribute18
      attribute19
      attribute20
      attribute21
      attribute22
      attribute23
      attribute24
      attribute25
      attribute26
      attribute27
      attribute28
      attribute29
      attribute30
      attribute31
      attribute32
      attribute33
      attribute34
      attribute35
      attribute36
      attribute37
      attribute38
      attribute39
      attribute40
      attribute41
      attribute42
      attribute43
      attribute44
      attribute45
      attribute46
      attribute47
      attribute48
      attribute49
      attribute50
      name
      email
      categories
      employeesize
      yearsinbusiness
      businessstartdate
      typeofentity
      map
      website
      gmb
      yelp
      tripadvisor
      youtubeurl
      shortdesc
      longdesc
      orgattribute1
      orgattribute2
      orgattribute3
      orgattribute4
      orgattribute5
      orgattribute6
      orgattribute7
      orgattribute8
      orgattribute9
      orgattribute10
      orgattribute11
      orgattribute12
      orgattribute13
      orgattribute14
      orgattribute15
      orgattribute16
      orgattribute17
      orgattribute18
      orgattribute19
      orgattribute20
      orgattribute21
      orgattribute22
      orgattribute23
      orgattribute24
      orgattribute25
      orgattribute26
      orgattribute27
      orgattribute28
      orgattribute29
      orgattribute30
      orgattribute31
      orgattribute32
      orgattribute33
      orgattribute34
      orgattribute35
      orgattribute36
      orgattribute37
      orgattribute38
      orgattribute39
      orgattribute40
      orgattribute41
      orgattribute42
      orgattribute43
      orgattribute44
      orgattribute45
      orgattribute46
      orgattribute47
      orgattribute48
      orgattribute49
      orgattribute50
      orgwebsite
      orgphonenumber
      orgtwitter
      orgfacebook
      orglinkedin
      orgyoutubeurl
      orggmb
      orgyelp
      orgtripadvisor
      orgmap
      orgemail
      orgtags
      orgsource
      orgstatus
      revenue
      emailstatus
      phonenostatus
      phoneverifydata
    }
    selectedColumn {
      columnname
      dbcolumnname
      table
      datatype
    }
  }
}`;

export const DeleteFilter = `
mutation deletePinnedFilter($ownerid: ID!, $locationid: ID!, $type: Int) {
  deletePinnedFilter(ownerid: $ownerid, locationid: $locationid, type: $type)
}`;

export const EditView = `
mutation editUser($userid:ID!, $defaultcontactview:Int) {
  editUser(userid:$userid, defaultcontactview:$defaultcontactview)
}`;

export const savedFiltersByUserAndLocation = `
  query savedFiltersByUserAndLocation($ownerid: ID!,$locationid:ID!,$type: Int){
  savedFiltersByUserAndLocation(ownerid:$ownerid,locationid:$locationid,type: $type){
    userfilters {
      filterid,name,description,businessid,table,type,query,createdby,updatedby,locationid,deleted
    }
    locationfilters {
      filterid,name,description,businessid,table,type,query,createdby,updatedby,locationid,deleted
    }
  }
}`;

export const ContactColumnValues = `query contactcolumnvalues($columnname:String!,$table:String!,$locationid:ID!,$pagesize:Int,$pagenumber:Int,$searchtext: String){
  contactcolumnvalues(columnname:$columnname,table:$table,locationid:$locationid,pagesize:$pagesize,pagenumber:$pagenumber,searchtext:$searchtext){
      name,value
    }
}`;

export const UpdateTargetContact = `
mutation
updatetargetlistcontact(
  $contactids: [ID!]!,
  $istargetlist: Boolean
    ){
      updatetargetlistcontact(
          contactids: $contactids,
          istargetlist: $istargetlist 
        )
}`;

export const GenerateAiEmail = `mutation GenerateAIEmail($searchtext: String!, $businessid: ID!, $locationid: ID!, $ownerid: ID!, $createdby: ID!, $keywords: String) {
  generateAIEmail(searchtext: $searchtext, businessid: $businessid, locationid: $locationid, ownerid: $ownerid, createdby: $createdby, keywords: $keywords) {
    response
    subjectline
  }
}`;

export const BusinessAiCredit = `query Businessusagebybusinesswithtype($businessid: ID!) {
  businessusagebybusinesswithtype(businessid: $businessid) {
    aiquery
    aiquerylimit
    isunlimitedaiquery
  }
}`;

export const SavedFilter = `query savedfilter($filterid: ID!){
  savedfilter(filterid:$filterid){
        filterid
        name
        description
        businessid
        table
        type
        query
        createdby
        updatedby
        locationid
        deleted
        }
}`;

export const CreateSavedFilter = `
  mutation createsavedfilter(
      $name: String!
      $table: String!
      $type: Int!
      $description: String
      $ownerid: ID!
      $query: String
      $createdby: ID
      $locationid: ID!
      $systemfilterquery: String
        ){
      createsavedfilter(
        name:$name
        table:$table
        type:$type
        query:$query
        description:$description
        ownerid:$ownerid
        createdby:$createdby
        locationid:$locationid
        systemfilterquery: $systemfilterquery
        ){
          filterid,name,table,type,query,description,createdby,updatedby,locationid,deleted,systemfilterquery
        }
}`;

export const DeleteSavedFilter = `mutation
deletesavedfilter(
  $filterid: ID!
    ){
      deletesavedfilter(
        filterid:$filterid
        )
}`;

export const CreateColumnMutation = `
mutation
saveSelectedGridColumns(
  $columns: [columns!]
  $filterid: ID
  $type: Int
  $ownerid: ID!
  $createdby: ID
  $locationid: ID!
  $businessid: ID!
  $isforallrecords: Boolean
    ){
      saveSelectedGridColumns(
        columns: $columns
        filterid: $filterid
        type: $type
        ownerid: $ownerid
        createdby: $createdby
        locationid: $locationid
        businessid: $businessid
        isforallrecords: $isforallrecords
        ){
          gridcolumnsid
          columnname
          dbcolumnname
          table
          type
        }
}`;

export const DeleteContact = `mutation DeleteContact($contactids: [ID!], $locationid: ID, $searchText: String, $advancedfilter: [AdvancedFilter!], $filterid: ID, $selectiontype: Int) {
  deleteContact(contactids: $contactids, locationid: $locationid, searchText: $searchText, advancedfilter: $advancedfilter, filterid: $filterid, selectiontype: $selectiontype)
}`;

export const ContactActivitiesByContact = `
query contactActivitiesByContact(
        $contactid: ID!,
        $objecttype: [Int],
        $startdate: String,
        $enddate: String
    ){
    contactActivitiesByContact(
        contactid:$contactid,
        objecttype: $objecttype,
        startdate: $startdate,
        enddate: $enddate
    ){
        activityid
        title
        description
        objectid
        objecttype
        createdby
        updatedby
        createdUser{ userid,firstname,lastname,phonenumber,email}
        deleted
        contactid
        createdAt
        updatedAt
        emailreport {
          status
          unsubscribeddate
          openeddate
          delivereddate
          emailid
          clickeddate
          bounceddate
        }
 }}`;

export const DeleteNotes = `
mutation deleteContactNote(
    $contactnoteid: ID!
){
    deleteContactNote(
        contactnoteid: $contactnoteid
    )
}`;

export const DeleteContactTask = `
mutation
deleteContactTask(
    $taskid: ID!
){
    deleteContactTask(
        taskid: $taskid
    )
}`;

export const EmailVerify = gql`
subscription updateEmailverificationStatus($email: String!){
  updateEmailverificationStatus(email: $email){ 
    email, status
}}`;

export const VerifyEmail = `
mutation
verifyemail(
  $contactid: ID!, $email:String!
){
  verifyemail(
    contactid: $contactid, email:$email
  )
}`;

export const StateByCountry = 'query statebycountry($countryId:Int!){statesbycountry(countryid:$countryId){stateid,name,code}}';

export const ContactDocumentesByOrganization = `query ContactDocumentesByOrganization($organizationid: ID!) {
  contactDocumentesByOrganization(organizationid: $organizationid) {
    documentid
    title
    description
    documents
    status
    type
    realestatepropertyid
    createdby
    updatedby
    ownerUser {
      firstname
      lastname
    }

    deleted
    contactid
    organizationid
    createdAt
    updatedAt
  }
}`;

export const ContactDocumentesByContact = `query ContactDocumentesByContact($contactid: [ID!]) {
  contactDocumentesByContact(contactid: $contactid) {
    documentid
    title
    description
    documents
    status
    createdby
    updatedby
    ownerUser {
      firstname
      lastname
    }
    deleted
    comments {
      commentid
      description
      parentid
      createdAt
      updatedAt
    }
    contactid
    createdAt
    updatedAt
  }
}`;

export const ContactDocument = `
query contactDocument($documentid: ID!){
 contactDocument(documentid:$documentid){
  documentid
  title
  description
  documents
  status
  createdby
  updatedby
  ownerUser {
    firstname
    lastname
  }
  deleted
  comments {
    commentid
    description
    parentid
    createdAt
    updatedAt
  }
  contactid
  createdAt
  updatedAt
  emailbody
 }}`;

export const UpdateDocument = gql`
mutation
editContactDocument(
    $documentid: ID!
    $title: String!
    $contactid: ID
    $organizationid: ID
    $description: String
    $documents: [Upload!]
    $status: Int
    $updatedby: ID!
    $folderid: ID
){
    editContactDocument(
        documentid: $documentid
        title: $title
        contactid: $contactid
        organizationid: $organizationid
        description: $description
        documents:  $documents
        status: $status
        updatedby: $updatedby
        folderid: $folderid
    )
}`;

export const CreateDocument = gql`
mutation
createContactDocument(
    $title: String!
    $description: String
    $documents: [Upload!]
    $status: Int
    $contactid: ID
    $organizationid: ID
    $createdby: ID!
    $folderid: ID
){
    createContactDocument(
        title: $title
        description: $description
        documents:  $documents
        status: $status
        contactid: $contactid
        organizationid: $organizationid
        createdby: $createdby
        folderid: $folderid
    ){
        documentid
        title
        documents
        status
        description
        createdby
        deleted
        contactid
        organizationid
        createdAt
        updatedAt
    }
}`;

export const DeleteDocument = `
mutation
deleteContactDocument(
    $documentid: ID!
    $contactid: ID
){
    deleteContactDocument(
        documentid: $documentid
        contactid: $contactid
    )
}`;

export const EditContactTask = `mutation EditContactTask($taskid: ID!, $updatedby: ID!, $taskname: String, $taskdescription: String, $priority: Int, $duedate: String, $tasktype: Int, $remindertype: Int, $reminderdate: String, $assigneduser: [ID!], $status: Int, $isarchived: Boolean, $associatedconnnect: [ID!], $ownerid: ID, $contactid: ID, $timezone: String, $eventtiming: Int, $iscreateevent: Boolean) {
  editContactTask(taskid: $taskid, updatedby: $updatedby, taskname: $taskname, taskdescription: $taskdescription, priority: $priority, duedate: $duedate, tasktype: $tasktype, remindertype: $remindertype, reminderdate: $reminderdate, assigneduser: $assigneduser, status: $status, isarchived: $isarchived, associatedconnnect: $associatedconnnect, ownerid: $ownerid, contactid: $contactid, timezone: $timezone, eventtiming: $eventtiming, iscreateevent: $iscreateevent)
}`;

export const CallListByCallSid = `query calllistbycallsid($callsid: String!){
  calllistbycallsid(callsid: $callsid){
  callstatusid,sid,callsid,locationid,businessid,status
}
}`;

export const CreateCallMutation = `
mutation createCallId($phoneNumber: String!)
  {
    createCallId(phoneNumber:$phoneNumber) 
      {
        validationCode
      }
}`;

export const CallStatus = gql`
subscription callStatus($from: String!, $to: String!){
 callStatus(from:$from, to:$to)}`;

export const CheckStatus = `query checkStatus($number:String!){
  checkStatus(number:$number)
}`;

export const ContactFormSetting = `query contactformsetting($formId: ID!){contactformsetting(formid: $formId){
  formid
  formtype
  name
  calloutbuttontype
  featureimageurl
  callouttext
  calloutbody
  calloutbuttontext
  calloutbuttonfileurl
  themecolor
  textcolor
  backgroundcolor
  calloutbuttontype
  calloutbuttonlink
  formbody
  isfirstnameshow
  islastnameshow
  isemailshow
  isphoneshow
  isfixedposition
  formsubmitbuttontext
  contactlifecyclestage
  thanksmessage
  isshowthanksbutton
  isshowfiledselection
  status
  activedate
  thanksbuttontext
  thanksbuttontype
  thanksbuttonlink
  thanksbuttonfileurl
  triggeronload
  isshowfooterlogo
  triggeronhalfpagecroll
  triggeronexitintent
  triggerafterelapsedtime
  triggertime
  triggerposition
  locationid
  issendthanksemail
  issendthankssms
  thanksemailconfig
  thankssmsconfig
  workflowid
  termenable
  termdesc
  calloutbtnposition
  captchaenable
  formposition
}}`;

export const Countries = '{countries{countryid,name}}';
export const States = '{states{stateid,name,country{countryid}}}';

export const SystemFilter = `query SystemFilters {
  systemFilters {
    name
    value
  }
}`;

export const ContactAppointment = `query Eventsbylocation($locationid: ID!) {
  eventsbylocation(locationid: $locationid) {
    name
  }
}`;

export const CustomFormByLocationAndType = `query CustomFormByLocationAndType($locationid: ID!, $formtype: Int!) {
  customFormByLocationAndType(locationid: $locationid, formtype: $formtype) {
    customformid
    fields
    formtype
    createdby
    updatedby
    locationid
    businessid
    deleted
  }
}`;

export const CreateCustomForm = `mutation CreateCustomForm($fields: String!, $formtype: Int!, $businessid: ID!, $locationid: ID!, $createdby: ID) {
  createCustomForm(fields: $fields, formtype: $formtype, businessid: $businessid, locationid: $locationid, createdby: $createdby) {
    customformid
    fields
    formtype
    createdby
    updatedby
    locationid
    businessid
    deleted
  }
}`;

export const EditCustomForm = `mutation EditCustomForm($customformid: ID!, $fields: String!, $formtype: Int, $updatedby: ID) {
  editCustomForm(customformid: $customformid, fields: $fields, formtype: $formtype, updatedby: $updatedby)
}`;

export const DeleteCustomForm = `mutation DeleteCustomForm($customformid: ID!) {
  deleteCustomForm(customformid: $customformid)
}`;

export const CreateContactOrganization = `mutation CreateContactOrganization($createdby: ID!, $responsedata: String!, $locationid: ID!, $businessid: ID!) {
  createContactOrganization(createdby: $createdby, responsedata: $responsedata, locationid: $locationid, businessid: $businessid) {
    contactid
    organizationid
    error
  }
}`;

export const TagsLisByLocation = `query TagListByLocation($locationid: ID!, $searchtext: String) {
  tagListByLocation(locationid: $locationid, searchtext: $searchtext) {
    tagid
    tagname
    tagdescription
    workflows {
      name
      workflowid
    }
    contactcount
  }
}`;
export const DeleteTagsByLocation = `mutation DeleteTagFromContact($locationid: ID!, $tags: String!) {
  deleteTagFromContact(locationid: $locationid, tags: $tags)
}`;
export const CreateTag = `mutation CreateTag($tagname: String!, $locationid: ID!, $businessid: ID!, $createdby: ID!, $tagdescription: String) {
  createTag(tagname: $tagname, locationid: $locationid, businessid: $businessid, createdby: $createdby, tagdescription: $tagdescription) {
    tagdescription
  }
}`;
export const EditTag = `mutation EditTag($tagid: ID!, $tagname: String!, $updatedby: ID!, $tagdescription: String) {
  editTag(tagid: $tagid, tagname: $tagname, updatedby: $updatedby, tagdescription: $tagdescription)
}`;
export const CreateMultipleCustomer = `mutation CreateMultipleCustomer($ownerid: ID!, $customerData: [customerInput!], $locationid: ID, $lifecyclestage: String, $source: [String], $status: Int, $createdby: ID, $tags: [String], $errordata: String, $totalrecords: Int, $validrecords: Int, $invalidrecords: Int, $filename: String, $businessid: ID, $workflowid: ID) {
  createMultipleCustomer(ownerid: $ownerid, customerData: $customerData, locationid: $locationid, lifecyclestage: $lifecyclestage, source: $source, status: $status, createdby: $createdby, tags: $tags, errordata: $errordata, totalrecords: $totalrecords, validrecords: $validrecords, invalidrecords: $invalidrecords, filename: $filename, businessid: $businessid, workflowid: $workflowid)
}`;

export const ImportContactAndOrg = `mutation ImportContactsAndOrg($customerData: [customerInput!], $locationid: ID, $lifecyclestage: String, $source: [String], $status: Int, $createdby: ID, $tags: [String], $errordata: String, $totalrecords: Int, $validrecords: Int, $invalidrecords: Int, $filename: String, $businessid: ID, $workflowid: ID, $isuniquelinkedin: Boolean) {
  importContactsAndOrg(customerData: $customerData, locationid: $locationid, lifecyclestage: $lifecyclestage, source: $source, status: $status, createdby: $createdby, tags: $tags, errordata: $errordata, totalrecords: $totalrecords, validrecords: $validrecords, invalidrecords: $invalidrecords, filename: $filename, businessid: $businessid, workflowid: $workflowid, isuniquelinkedin: $isuniquelinkedin)
}`;

export const ContactListByContactId = `query ContactListByContactId($locationid: ID!, $contactids: [ID!]!) {
  contactListByContactId(locationid: $locationid, contactids: $contactids) {
    existOrg
    missingOrg
    existEmail
  }
}`;

export const Emailreportbyemail = `query Emailreportbyemail($emailid: ID!) {
  emailreportbyemail(emailid: $emailid) {
    emailreportid,senttime,delivereddate,openeddate,clickeddate,bounceddate,unsubscribeddate
  }
}`;

export const AssigneWorkflowByTag = `mutation AssigneWorkflowByTag($tagname: String!, $locationid: ID!, $businessid: ID!, $updatedby: ID!, $tagid: ID, $workflowids: [ID!]) {
  assigneWorkflowByTag(tagname: $tagname, locationid: $locationid, businessid: $businessid, updatedby: $updatedby, tagid: $tagid, workflowids: $workflowids)
}`;

export const CreateCertificate = `mutation CreateCertificate($servicename: String!, $locationid: ID!, $createdby: ID!, $projectstartdate: String, $projectenddate: String, $certificationagency: String, $certifcationvalidity: String, $certificatesa1Due: String, $certificateRenewed1: String, $certificatesa2Due: String, $certificateRenewed2: String, $repeatbusiness: String, $beforreminder: Int, $assigneduser: [ID!], $status: Int, $associatedcontact: [ID!], $ownerid: ID, $organizationid: ID, $timezone: String) {
  createCertificate(servicename: $servicename, locationid: $locationid, createdby: $createdby, projectstartdate: $projectstartdate, projectenddate: $projectenddate, certificationagency: $certificationagency, certifcationvalidity: $certifcationvalidity, certificatesa1due: $certificatesa1Due, certificateRenewed1: $certificateRenewed1, certificatesa2due: $certificatesa2Due, certificateRenewed2: $certificateRenewed2, repeatbusiness: $repeatbusiness, beforreminder: $beforreminder, assigneduser: $assigneduser, status: $status, associatedcontact: $associatedcontact, ownerid: $ownerid, organizationid: $organizationid, timezone: $timezone) {
    certificateid
    servicename
    projectstartdate
    projectenddate
    certificationagency
    certifcationvalidity
    certificatesa1due
    certificateRenewed1
    certificatesa2due
    certificateRenewed2
    repeatbusiness
    beforreminder
    remindersent
    secondreminder
    assigneduser
    status
    associatedcontact
    ownerid
    createdby
    updatedby
    isarchived
    organizationid
    createdUser {
      firstname
      lastname
    }
    ownerUser {
      lastname
      firstname
    }
    createdAt
    updatedAt
    timezone
  }
}`;

export const EditCertificate = `mutation EditCertificate($certificateid: ID!, $updatedby: ID!, $servicename: String, $projectstartdate: String, $projectenddate: String, $certificationagency: String, $certifcationvalidity: String, $certificatesa1Due: String, $certificateRenewed1: String, $certificatesa2Due: String, $certificateRenewed2: String, $repeatbusiness: String, $assigneduser: [ID!], $associatedcontact: [ID!]) {
  editCertificate(certificateid: $certificateid, updatedby: $updatedby, servicename: $servicename, projectstartdate: $projectstartdate, projectenddate: $projectenddate, certificationagency: $certificationagency, certifcationvalidity: $certifcationvalidity, certificatesa1due: $certificatesa1Due, certificateRenewed1: $certificateRenewed1, certificatesa2due: $certificatesa2Due, certificateRenewed2: $certificateRenewed2, repeatbusiness: $repeatbusiness, assigneduser: $assigneduser, associatedcontact: $associatedcontact)
}`;

export const DeleteCertificate = `mutation DeleteCertificate($certificateid: ID!) {
  deleteCertificate(certificateid: $certificateid)
}`;

export const Certificates = `query Certificate($certificateid: ID!) {
  certificate(certificateid: $certificateid) {
    certificateid
    servicename
    projectstartdate
    projectenddate
    certificationagency
    certifcationvalidity
    certificatesa1due
    certificateRenewed1
    certificatesa2due
    certificateRenewed2
    repeatbusiness
    beforreminder
    remindersent
    secondreminder
    assigneduser
    status
    associatedcontact
    ownerid
    createdby
    updatedby
    isarchived
    organizationid
    createdAt
    updatedAt
    timezone
  }
}`;

export const CertificatesByOrganization = `query CertificatesByOrganization($organizationid: ID!, $contactids: [ID!], $searchtext: String, $status: Int, $orderby: String) {
  certificatesByOrganization(organizationid: $organizationid, contactids: $contactids, searchtext: $searchtext, status: $status, orderby: $orderby) {
    certificateid
    servicename
    projectstartdate
    projectenddate
    certificationagency
    certifcationvalidity
    certificatesa1due
    certificateRenewed1
    certificatesa2due
    certificateRenewed2
    repeatbusiness
    assigneduser
    associatedcontact
    organizationid
    associatedcontacts {
      firstname
      lastname
    }
    assignedusers {
      firstname
      lastname
    }
    createdUser {
      firstname
      lastname
    }
    ownerUser {
      firstname
      lastname
    }
    createdAt
    updatedAt
    timezone
  }
}`;